export default function getPassengerTypeApiKeys(typeCode) {
  switch (typeCode) {
    case 'A':
      return 'adults'
    case 'Z':
      return 'seniors'
    case 'S':
      return 'youths'
    case 'C':
      return 'children'
    case 'I':
      return 'infants'
    default:
      return ''
  }
}
